import { useQuery } from 'react-query';

import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { TIME_VALUES } from '~/Constants/Date.constants';
import { PROVIDER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IStudioName } from '~/Screens/Onboarding/models/studioName.models';

export const useCheckProviderName = (studioName: string) =>
  useQuery<IStudioName, IErrorResponse>(
    [REQUEST_ACTIONS.CHECK_STUDIO_NAME],
    () =>
      requestReactQuery<IStudioName>({
        url: PROVIDER_SERVICE_URLS.VERIFY_STUDIO_NAME,
        config: { method: 'GET' },
        params: { studioName },
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: true,
      refetchInterval: TIME_VALUES.HOUR,
      enabled: !!studioName,
    },
  );
